module.exports = __webpack_public_path__ + "img/encore-book-icon.c1e827af.svg";